import React, { forwardRef } from 'react';
import s from './UnreadBanner.module.scss';

type UnreadBannerProps = {
  count: number;
};

const UnreadBanner = forwardRef<HTMLLIElement, UnreadBannerProps>(({ count }, ref) => (
  <li
    className={s.root}
    ref={ref}
  >
    {count === 1 ? '1 Unread Message' : `${count} Unread Messages`}
  </li>
));

UnreadBanner.displayName = 'UnreadBanner';

export default UnreadBanner;
